
import { Class } from './class.js';
import { Validatable } from 'haberdash';


export const Model = Class.extend().include({
    meta(){
        this.include(Validatable);

        this.assignProps({
            mustNotBeBlank(name, options = {}){
                const { message = 'Must not be blank', when = () => true } = options;
                return this.addHook('validation', async function(){
                    if(this.isValidationError(name)) return;
                    if(! await when.call(this, this)) return;
                    const value = `${this[name] || ''}`.trim();
                    if(value == ''){
                        this.setValidationError(name, message);
                    }
                });
            },

            mustMatchPattern(name, pattern, options = {}){
                const { message = 'Must match pattern', when = () => true } = options;
                return this.addHook('validation', async function(){
                    if(this.isValidationError(name)) return;
                    if(! await when.call(this, this)) return;
                    const value = `${this[name] || ''}`.trim();
                    if(!value.match(pattern)){
                        this.setValidationError(name, message);
                    }
                });
            },

            mustBeAValidEmail(name, options = {}){
                const { message = 'Must be a valid email',  ...otherOptions } = options;
                return this.mustMatchPattern(name, /^[^@]+@[^@]+$/, { message, ...otherOptions });
            },

            toFormAdapter(){
                return this.new().toFormAdapter();
            }
        });
    },

    initialize(fields = {}){
        this._initialFields = { ...fields };
        Object.assign(this, fields);
    },

    toFormAdapter(){
        const fields = [];

        for(const [name, value] of Object.entries(this._initialFields)){
            fields.push({ name, value });
        }

        return {
            title: 'Submit',
            fields,
            submitTitle: 'Submit',
            cancelTitle: 'Cancel',
            submit: async (values, options = {}) => {
                const { success = () => {}, validateWith } = options;
                Object.assign(this, values);
                await this.validate({ validateWith });
                return success(this);
            }
        }
    }
});

